import {API} from "./API";
import {Role} from "../models/Role";

export class RolesAPI extends API<Role> {

	constructor () {
		super("roles");
	}
}
